module.exports = __webpack_public_path__ + "static/media/equipamentos_amamentacao2.5b1e5164.jpg";